import { z } from 'zod'
import { AnyUrnSchema } from '../unique-id.models.ts'

export const ActivityDataTargetSchema = z.object({
  name: z.string(),
  urn: AnyUrnSchema,
})
export type ActivityDataTarget = z.infer<typeof ActivityDataTargetSchema>
